import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";

type Props = {
	hotelID: string;
};

export const ContactTopPageHeaderRightChildren = ({ hotelID }: Props) => {
	const FAQPagePath = generatePath(PATHS.FAQ, { hotelID });
	const contactNewPagePath = generatePath(PATHS.HOTEL.CONTACT.NEW, { hotelID });

	const navigate = useNavigate();

	const handleClickNavigateToFAOPageButton = useCallback(() => {
		navigate(FAQPagePath);
	}, [FAQPagePath, navigate]);

	const handleClickNavigateToContactNewPageButton = useCallback(() => {
		navigate(contactNewPagePath);
	}, [contactNewPagePath, navigate]);

	return (
		<div className="flex gap-x-6">
			<Button size="lg" type="button" variant="outline" onClick={handleClickNavigateToFAOPageButton}>
				よくある問い合わせ
			</Button>
			<Button size="lg" type="button" onClick={handleClickNavigateToContactNewPageButton}>
				質問する
			</Button>
		</div>
	);
};

ContactTopPageHeaderRightChildren.displayName = "ContactTopPageHeaderRightChildren";
